export const hotelroomDialogues: any[] = [
    {
        id: 1,
        dialogue: [
            `
            `,
        ],
        options: [{ id: 1, action: "option 1", roomId: 9 }],
    },
    {
        id: 2,
        dialogue: [
            `
        `,
        ],
        options: [{ id: 1, action: "option 1", roomId: 9 }],
    },
    {
        id: 3,
        dialogue: [
            `
        `,
        ],
        options: [{ id: 1, action: "option 1", roomId: 9 }],
    },
    {
        id: 4,
        dialogue: [
            `
        `,
        ],
        options: [{ id: 1, action: "option 1", roomId: 9 }],
    },
    {
        id: 5,
        dialogue: [
            `
        `,
        ],
        options: [{ id: 1, action: "option 1", roomId: 9 }],
    },
    {
        id: 99,
        dialogue: [
            `
        `,
        ],
        options: [
            { id: 1, action: "GEEN OPTION, VRAAG MITCHEL, ID 99 IS VOOR EXIT ROOM NAAR VOLGENDE", roomId: 9 },
        ],
    },
];
